<template>
  <base-layout
    :value="value"
    :label-width="labelWidth"
    :text-align="textAlign"
    :is-require="isRequire"
    :is-dipatch="isDipatch"
    :label="label"
  >
    <template v-if="multiple">
      <el-radio-group @change="handleChange" slot="control" v-model="inputValue">
        <el-radio
          :key="`${$index}--checkbox`"
          v-for="(item, $index) in getOptions"
          :disabled="item.disabled || readOnly"
          :label="item.comment"
        ></el-radio>
      </el-radio-group>
    </template>
    <template v-else>
      <el-radio
        slot="control"
        v-model="inputValue"
        :disabled="disabled || readOnly"
        :label="iconLabel"
      >{{iconLabel}}</el-radio>
    </template>
  </base-layout>
</template>

<script>
import baseLayout from "./base-layout.vue";
import { handleEmitValue, datePicker } from "./../props-config";
import { baseCheckbox } from "./../props-config";
import * as API from "./base-enum-remote";

export default {
  name: "base-radio",
  components: {
    baseLayout
  },
  computed: {
    inputValue: {
      get() {
        if (this.getType === 1) {
          return this.value;
        } else if (this.getType === 2) {
          const selectValue = this.getOptions.find(
            item => item.code === this.value
          );
          if (selectValue) return selectValue["comment"];
          return "";
        }
      },
      set(val) {
        if (this.isDipatch) {
          if (this.getType === 1) {
            this.$store.dispatch("updateObject", {
              obj: this.dipatchObj,
              attr: this.dipatchAttr,
              val: val
            });
          } else {
            const selectValue = this.getOptions.find(
              item => item.comment === val
            );
            if (selectValue) {
              this.$store.dispatch("updateObject", {
                obj: this.dipatchObj,
                attr: this.dipatchAttr,
                val: selectValue["code"]
              });
            }
          }
        } else {
          if (this.getType === 1) {
            return this.$emit("input", val);
          } else if (this.getType === 2) {
            const selectValue = this.getOptions.find(
              item => item.comment === val
            );
            if (selectValue) {
              return this.$emit("input", selectValue["code"]);
            }
            return "";
          }
        }
      }
    },
    getOptions() {
      // 如果是拉去服务器下拉
      if (this.apiName) {
        return this.list;
      } else {
        return this.options;
      }
    }
  },
  props: {
    ...baseCheckbox,
    multiple: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    apiName: {
      type: String,
      default: ""
    },
    iconLabel: {
      type: String,
      default: ""
    },
    // 接受固定参数,
    params: {
      type: [Object, Array],
      default: () => ({})
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 99
    },
    // 1 -> 返回comment 2 -> 返回code
    getType: {
      type: Number,
      default: 1
    },
    // 1 -> 竖 2-> 横
    controlName: {
      type: [String],
      default: "el-col"
    },
    // 0 -> 接受数组
    // 1 -> 接收Boolean
    // 2 -> 返回数字类型
    valueType: {
      type: Number,
      default: 0
    },
    label:{
      type: String,
      default: ''
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    handleChange(val) {
      this.handleEmitValue(val);
    },
    handleEmitValue,
    // 拉去固定参数的数据
    syncGetOptions(params) {
      return API.syncGetEnum(this.apiName, params).then(res => {
        this.list = res;
      });
    },
    init() {
      if (this.apiName) {
        this.syncGetOptions(this.params);
      }
    }
  },
  data() {
    return {
      list: []
    };
  }
};
</script>

<style>
.base-input-value__checkgroup {
  margin-right: 20px;
}
/* .el-checkbox__inner::after {
		background-color: #fff;
	}
	.el-checkbox__inner::before {
		position: absolute;
		content: '';
		width: 4px;
		height: 8px;
		background-color: red;
		left: 5px;
		top: 1px;
	} */
</style>
